<script>
import TopNavbar from "@/layout/dashboard/TopNavbar.vue";
import {axiosApiInstance} from "@/axiosInterceptor";
import router from "@/router";

export default {
  name: 'referent-index',
  components: {
    TopNavbar,
  },
  data() {
    return {
      referent: {},
      users: {},
      flash: null,
    }
  },
  mounted() {
    this.getReferent()
  },
  methods: {
    clearFlash() {
      this.flash = null
    },
    updateFlash(message, type) {
      this.flash = {message: message, type: type}
      setTimeout(() => {
        this.clearFlash()
      }, 3000)
    },
    returnToList() {
      router.push('/referent')
    },
    getReferent() {
      axiosApiInstance.get(process.env.VUE_APP_API_URL + '/referent/' + this.$route.params.id).then(response => {
        this.referent = response.data.referent
        this.getUserList()
      }).catch(() => {
        this.updateFlash("Une erreur est survenue.", 'danger')
      })
    },
    getUserList() {
      axiosApiInstance.get(process.env.VUE_APP_API_URL + '/referent/users/' + this.$route.params.id).then(response => {
        this.users = response.data.users
      }).catch(() => {
        this.updateFlash("Une erreur est survenue.", 'danger')
      })
    }
  }
}

</script>

<template>
  <div class="wrapper">
    <div class="position-fixed top-0 start-50 translate-middle-x p-3" style="z-index: 11;padding-top:33px !important;">
      <div :class="'toast bg-' + flash.type + ' ' + (flash?'show':'hide')" v-if="flash">
        <div class="d-flex">
          <div class="toast-body">
            {{ flash.message }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
                  aria-label="Fermer" @click="clearFlash"></button>
        </div>
      </div>
    </div>

    <side-bar>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <div class="content">
        <h1>Liste des candidats</h1>
        <button class="btn btn-primary mb-5" @click="returnToList()">Retour à la liste</button>
        <table class="table text-center">
          <thead>
          <tr>
            <th class="text-left">Date de création</th>
            <th class="text-left">Nom</th>
            <th class="text-left">Prénom</th>
            <th class="text-left">Email</th>
            <th class="text-left">Terminé ?</th>

          </tr>
          </thead>
          <tbody>
          <tr v-if="users && users.length > 0" v-for="user in users">
            <td class="text-left">{{ user.createdAt }}</td>
            <td class="text-left">{{ user.lastName }}</td>
            <td class="text-left">{{ user.firstName }}</td>
            <td class="text-left">{{ user.email }}</td>
            <td class="text-left">{{ user.finished ? 'Oui' : 'Non' }}</td>
          </tr>
          <tr v-else>
            <td colspan="4">
              Aucun candidat trouvé
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>